import React, { useState, useEffect } from 'react';

import { Container, Etapa, NumeroEtapa, StringEtapa, Linha, BtnAvancarVoltar } from './stylesSteps';
import { MdDone, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import Toastify from '~/components/Toastify';

const Steps = ( { data, value, manipulador } ) => {
    let largura = window.innerWidth;
    console.log( largura );
    function manipulaEtapas ( avancar ) {

        if ( avancar ) {
            //      if ( !data[ value ].condicao )
            //      return Toastify.error( data[ value ].errorMensagem );

            manipulador( old => {
                if ( old + 1 >= data.length ) {
                    return data.length - 1;
                } else {
                    return old + 1;
                }
            }, data.length - 1 === value );
        } else {
            manipulador( old => old-- <= 0 ? 0 : old++ );
        }
    }

    return (
        <Container>
            <BtnAvancarVoltar onClick={ () => manipulaEtapas() }> <MdKeyboardArrowLeft /> Voltar </BtnAvancarVoltar>
            { data.map( ( item, index, all ) => {
                return (
                    <React.Fragment key={ item.name }>
                        <Etapa >
                            <StringEtapa atual={ value == index } passou={ value > index } style={ { display: largura < 400 && value != index ? 'none' : 'flex' } }>
                                { item.text }
                            </StringEtapa>
                        </Etapa>
                        { index <= value && index != all.length - 1 && <Linha marcada={ value > index } /> }
                    </React.Fragment>
                );
            } ).filter( ( item, index, all ) => {
                if ( value == 0 ) {
                    return index <= 1;
                } else if ( value === all.length - 1 ) {
                    return index === ( all.length - 2 ) || index === value;
                } else {
                    return index === value || index === ( value - 1 ) || index === ( value + 1 );
                }

            } )
            }
            <BtnAvancarVoltar avancar onClick={ () => manipulaEtapas( true ) }> { data.length - 1 === value ? 'Concluir' : 'Próxima' } <MdKeyboardArrowRight /> </BtnAvancarVoltar>
        </Container>
    );
};

export default Steps;
